<template>
  <b-container fluid id="main-container">
    <div id="register">
     <h3>Register user</h3>
        <b-form @submit="register">
          <b-form-group class="input-group-admin" label="Email">
            <b-form-input
              type="text"
              v-model="email"
              placeholder="Enter email"
              @blur="validateEmail"
              
            ></b-form-input>
          </b-form-group>

          <b-form-group class="input-group-admin" label="Password">
            <b-form-input
              type="password"
              v-model="password"
              placeholder="Enter password"
              @blur="validatePassword"
              
            ></b-form-input>
          </b-form-group>

          <b-form-group class="input-group-admin" label="Password Confirmation">
            <b-form-input
              type="password"
              v-model="password_confirmation"
              placeholder="Confirm password"
              @blur="validatePassword"
            ></b-form-input>
          </b-form-group>
        <div class="center-button">
          <b-button pill v-on:click="register" id="button-register" type="button" variant="dark">Register</b-button>
        </div>
         
      </b-form>
      <div class="error"><p>{{error}}</p></div>
      </div>
  </b-container>
</template>
<script>
export default {
    name: "RegisterComponent",
    data(){
      return {
        email: "",
        password: "",
        password_confirmation: "",
        error: "",
      }
    },
    methods: {
      register: function () {
        let data = {
          email: this.email,
          password: this.password,
        }
        if (this.validateEmail() && this.validatePassword()) {
          console.log('jej')
          this.$store.dispatch('register', data)
         .then(() => this.$router.push('/'))
         .catch(err => this.error = err)
        }
      },
      
      validateEmail() {
        if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
            this.error = 'Please enter a valid email address!';
            return false;
        }
        else {
            this.error = '';
            return true;
        }

      },
      validatePassword() {
        var errors = [];
        if (this.password.length < 5) {
          errors.push("Your password must have at least 5 characters! "); 
        }
        if (this.password != this.password_confirmation) {
          errors.push("Passwords do not match! "); 
        }
        //if (p.search(/[a-z]/i) < 0) {
        //errors.push("Your password must contain at least one letter.");
        //}
        //if (p.search(/[0-9]/) < 0) {
        //errors.push("Your password must contain at least one digit."); 
        //}
        if (errors.length > 0) {
            this.error = errors.join("\n");
            return false;
        }
        this.error = '';
        return true;
      }

    }
  }
</script>script>

<style>

h3{
  text-align: center;
  margin-top:20px;
}

#button-register{

} 
.nav-bar{
  padding-left: 50px;;
}
.link{
  padding-right:100px;
  font-size: 20px;
  color:white;
}
.error {
  text-align: center;
  color: red;
  padding-top: 20px;
}
</style>